import { TextValidator } from "react-material-ui-form-validator"

const FillBlankQuestion = ({
  question,
  onChange,
  onBlur,
  isCompleted,
  questionIdx,
}) => {
  return (
    <div className="full-width" key={questionIdx}>
      <div className="form__fieldset">
        <span className="form__label">Question {questionIdx + 1}</span>
        <div className="form__fieldbox">
          <div className="form__masked-value">{question.title}</div>
        </div>
      </div>

      {question.parts.map((part, partIndex) =>
        part.type === 2 ? (
          <div className="form__fieldset" key={`text-part-${partIndex}`}>
            <span className="form__label">{/*Text part*/}</span>
            <div className="form__fieldbox">
              <div className="form__masked-value">
                <span>{part.text}</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="form__fieldset" key={`blank-part-${partIndex}`}>
            <span className="form__label">Answer</span>
            <div className="form__fieldbox">
              <div className="form__input">
                <TextValidator
                  name={`text-part-${partIndex + String(new Date())}`}
                  // value={user_answer_text_options[partIndex]}
                  value={question?.user_answer_text_options?.[0]}
                  placeholder={"Type your answer"}
                  className="edit-form__input"
                  margin="normal"
                  fullWidth
                  multiline
                  validators={["required", "maxStringLength:250"]}
                  errorMessages={[
                    "Field is required",
                    "Max length is 250 characters",
                  ]}
                  onChange={(event) => {
                    onChange(event, questionIdx, partIndex)
                  }}
                  onBlur={onBlur}
                  disabled={isCompleted}
                />
              </div>
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default FillBlankQuestion
